<app-dialog>
  <app-dialog-title>
    {{
      'ACCOUNT.GROUPS.BULK_DIALOG.TITLE'
        | translate: { name: data.group.name, childrenNamePlural: data.childrenNamePlural }
    }}
  </app-dialog-title>
  <app-dialog-content>
    <div class="add-venues">
      <div class="add-venues__toolbar">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="add-venues__search">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="text"
            [formControl]="searchControl"
            [placeholder]="'ACCOUNT.GROUPS.BULK_DIALOG.SEARCH_PLACEHOLDER' | translate"
            data-testid="input-bulk-search" />
        </mat-form-field>
        <button
          matButton
          type="button"
          [disabled]="!filteredCandidates().length"
          (click)="selectAllFiltered()"
          data-testid="btn-select-all">
          {{
            (hasSearchQuery()
              ? 'ACCOUNT.GROUPS.BULK_DIALOG.SELECT_ALL_FILTERED'
              : 'ACCOUNT.GROUPS.BULK_DIALOG.SELECT_ALL'
            ) | translate
          }}
        </button>
      </div>

      <div class="add-venues__list">
        @if (ungrouped().length) {
          <h3 class="add-venues__section-header">
            <span>{{ 'ACCOUNT.GROUPS.BULK_DIALOG.UNGROUPED' | translate }}</span>
            <span>{{ ungrouped().length }}</span>
          </h3>
          <ul class="add-venues__rows">
            @for (venue of ungrouped(); track venue.uuid) {
              <li>
                <mat-checkbox
                  class="add-venues__row"
                  [checked]="isSelected(venue)"
                  (change)="toggle(venue)"
                  [attr.data-testid]="'checkbox-venue-' + venue.uuid">
                  <span class="add-venues__row-content">
                    <span class="add-venues__row-name">{{ venue.brandName }}</span>
                  </span>
                </mat-checkbox>
              </li>
            }
          </ul>
        }

        @if (inGroups().length) {
          <h3 class="add-venues__section-header">
            <span>{{ 'ACCOUNT.GROUPS.BULK_DIALOG.IN_OTHER_GROUPS' | translate }}</span>
            <span>{{ inGroups().length }}</span>
          </h3>
          <ul class="add-venues__rows">
            @for (venue of inGroups(); track venue.uuid) {
              <li>
                <mat-checkbox
                  class="add-venues__row"
                  [checked]="isSelected(venue)"
                  (change)="toggle(venue)"
                  [attr.data-testid]="'checkbox-venue-' + venue.uuid">
                  <span class="add-venues__row-content">
                    <span class="add-venues__row-name">{{ venue.brandName }}</span>
                    <span class="add-venues__row-chips">
                      @for (groupName of groupNamesOf(venue).slice(0, 2); track groupName) {
                        <span class="add-venues__chip">{{ groupName }}</span>
                      }
                      @if (groupNamesOf(venue).length > 2) {
                        <span class="add-venues__chip add-venues__chip--overflow">
                          +{{ groupNamesOf(venue).length - 2 }}
                        </span>
                      }
                    </span>
                  </span>
                </mat-checkbox>
              </li>
            }
          </ul>
        }

        @if (!filteredCandidates().length) {
          <p class="add-venues__no-results">
            {{
              'ACCOUNT.GROUPS.BULK_DIALOG.NO_RESULTS'
                | translate
                  : { query: searchControl.value, childrenNamePlural: data.childrenNamePlural }
            }}
          </p>
        }
      </div>
    </div>
  </app-dialog-content>
  <app-dialog-actions>
    <span class="add-venues__selected-count" data-testid="text-selected-count">
      {{
        'ACCOUNT.GROUPS.BULK_DIALOG.SELECTED_COUNT'
          | translate: { selected: selectedCount(), total: data.candidates.length }
      }}
    </span>
    <button matButton="outlined" type="button" class="me-1" matDialogClose data-testid="btn-cancel">
      {{ 'ACCOUNT.GROUPS.BUTTONS.CANCEL' | translate }}
    </button>
    <button
      matButton="filled"
      type="button"
      [disabled]="!selectedCount()"
      (click)="confirm()"
      data-testid="btn-confirm-bulk-add">
      {{
        'ACCOUNT.GROUPS.BULK_DIALOG.ADD_BUTTON'
          | translate
            : {
                count: selectedCount(),
                childrenName:
                  selectedCount() === 1 ? data.childrenNameSingular : data.childrenNamePlural,
              }
      }}
    </button>
  </app-dialog-actions>
</app-dialog>
